// we want any here because the component just stringifies the remaining props of any type

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function debugLog(...args: any[]) {
  import.meta.env.DEV && console.log(args)
}
